import { useTranslation } from 'react-i18next';

// Status → pill styling. Keys match CONSULTATION_TASK_STATUS from the server.
const STATUS_STYLES = {
  ASSIGNED: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
  IN_PROGRESS: 'bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300',
  SUBMITTED: 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
  NEEDS_REVISION: 'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300',
  COMPLETED: 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300',
};

export default function StatusBadge({ status, className = '' }) {
  const { t } = useTranslation('consulting');
  const style = STATUS_STYLES[status] || STATUS_STYLES.ASSIGNED;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium rounded-full whitespace-nowrap ${style} ${className}`}
    >
      {t(`status.${status}`, status)}
    </span>
  );
}
